var React = require('react');

function IconAlert (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM11.9893 16.6113C11.5923 16.617 11.2132 16.7788 10.9346 17.0615C10.656 17.3442 10.5 17.7252 10.5 18.1221C10.5056 18.5153 10.6644 18.8909 10.9424 19.1689C11.2205 19.447 11.596 19.6057 11.9893 19.6113C12.3851 19.6078 12.764 19.4507 13.0459 19.1729C13.3278 18.8949 13.4908 18.5179 13.5 18.1221C13.4952 17.7229 13.334 17.3418 13.0518 17.0596C12.7695 16.7773 12.3884 16.6161 11.9893 16.6113ZM11.0176 14.9932H12.9824L13.3701 5H10.6084L11.0176 14.9932Z","fill":"#D63F2F"}));
}

IconAlert.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconAlert;

IconAlert.default = IconAlert;
